/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Status_RejectedInputs */

const id_profile_status_rejected = /** @type {(inputs: Profile_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditolak`)
};

const en_profile_status_rejected = /** @type {(inputs: Profile_Status_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Profile_Status_RejectedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_status_rejected = /** @type {((inputs?: Profile_Status_RejectedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Status_RejectedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_status_rejected(inputs)
	return id_profile_status_rejected(inputs)
});